import api from '@/apis'

export const fetchTenants = params => api.get('/tenants', { params })
export const deleteTenant = id => api.delete(`/tenants/${id}`)
export const fetchStaffConvs = params => api.get('/tenants/convs/find_staff_convs', { params })
export const getTenantById = id => api.get(`/tenants/${id}`)
export const createTenant = data => api.post('/tenants', data)
export const registerTenant = data => api.post('/tenants/register', data)
export const updateTenantById = (id, data) => api.put(`/tenants/${id}`, data)
export const changeBalance = (id, record) => api.put(`/tenants/${id}/change_balance`, record)
export const changeCredit = (id, record) => api.put(`/tenants/${id}/change_credit`, record)
export const sendCaptcha = data => api.post('/auth/captcha', data)
export const checkCaptcha = data => api.post('/auth/check_captcha', data)
export const tenantsRegister = data => api.post('/tenants/tenants/register', data)
export const tenantsStaffRegister = data => api.post('/tenants/staff/register', data)
export const getAccountList = params => api.get('/tenants/staff/accountList', { params })
export const accountAdd = data => api.post('/tenants/staff/accountAdd', data)
export const accountModifyPass = data => api.post('/tenants/staff/modifyPass', data)
export const accountDel = data => api.delete(`/tenants/staff/accountDel/${data.id}`, data)
export const seeMaster = data => api.post('/tenant/see/master', data)
export const seeWorkerTel = data => api.post('/tenant/see/worker_tel', data)
export const sendSmsAuto = data => api.post('/tenant/see/send_sms', data)
export const applyTenantOpenai = id => api.get(`/tenant/${id}/applyOpenai`)
export const opPrice = data => api.post('/tenant/op/price', data)
export const changeAdmin = data => api.post('/tenants/staff/changeAdmin', data)